@if (menu()) {
  <button
    [accredibleMenuTriggerFor]="menu()"
    [attr.data-cy]="dataCy()"
    [align]="'end'"
    [propagateClick]="false">
    <accredible-icon icon="menu-kebab" />
  </button>
}

@if (cdkMenuTemplateRef()) {
  <button [cdkMenuTriggerFor]="cdkMenuTemplateRef()" [attr.data-cy]="dataCy()">
    <accredible-icon icon="menu-kebab" />
  </button>
}
